module.exports = __webpack_public_path__ + "static/kilian-852622d7764518c386950d222a9414a9.jpg";